(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/caretech/caretech-checks/assets/javascripts/long-session.js') >= 0) return;  svs.modules.push('/components/caretech/caretech-checks/assets/javascripts/long-session.js');
'use strict';

const _svs$components$lbUti = svs.components.lbUtils.helpers.formatDate,
  getFormattedTime = _svs$components$lbUti.getFormattedTime,
  getFormattedDate = _svs$components$lbUti.getFormattedDate;
class LongSession {
  constructor() {
    this.extendedTimeValue = null;
    this.logger = svs.core.log.getLogger('components:caretech-checks');
    this.queueNumber = 0;
    this.isMomang = svs.core.config.data.svsconfig.site === 'momang';
  }
  trackInteraction(action, category, mandatory) {
    svs.components.analytics.trackEvent({
      action,
      category,
      opt_label: mandatory === false ? 'LongSession1' : 'LongSession2',
      opt_value: this.extendedTimeValue === null ? '-1' : this.extendedTimeValue
    });
  }
  getConfirmationTitleText(selectedTime) {
    if (selectedTime) {
      return selectedTime === '0' ? 'Du har valt att inte kunna spela mer just nu' : "Du kan spela upp till 90 minuter till";
    }
    return '';
  }
  getConfirmationBodyText(selectedTime, restrictedToTime) {
    if (selectedTime && restrictedToTime) {
      return selectedTime === '0' ? "Du kan spela vidare fr\xE5n ".concat(getFormattedTime(restrictedToTime), ".") : "Efter det b\xF6rjar en paus p\xE5 12 timmar.\n Du kan spela vidare fr\xE5n ".concat(getFormattedTime(restrictedToTime), ".");
    }
    return '';
  }
  initFormButtons(options) {
    const form = document.getElementById('long-session-check-fieldset');
    if (form) {
      this.radioButtons = document.querySelectorAll('.js-long-session-check .radio-button');
      this.radioButtons.forEach(radioButton => {
        radioButton.addEventListener('click', e => {
          this.timeLimitButtonClick(e);
        });
      });
    }
    if (options.mandatory === true) {
      document.querySelector('.dialog-header-close-icon-button').style.display = 'none';
    }
  }
  async caretechTracking(action, options) {
    const jsonData = {
      title: options.title,
      body: options.message,
      mandatory: options.mandatory,
      confirmationText: this.getConfirmationTitleText(this.extendedTimeValue) + this.getConfirmationBodyText(this.extendedTimeValue, options.restrictedToTime),
      buttonsData: [{
        value: 0,
        text: 'Ta en liten paus'
      }, {
        value: 90,
        text: 'Spela 90 min till'
      }]
    };
    if (this.queueNumber > 1) {
      jsonData.inQueue = true;
      jsonData.path = window.location.pathname;
      this.queueNumber = 0;
    }
    try {
      await svs.core.jupiter.callAsync({
        path: '/caretech/1/track/dialoginteraction',
        method: 'POST',
        data: {
          interactionId: options.interaction_id,
          dialogType: options.id,
          interaction: {
            type: action,
            target: String(this.extendedTimeValue === null ? -1 : this.extendedTimeValue)
          },
          mandatory: options.mandatory,
          dialogAsJson: JSON.stringify(jsonData)
        }
      });
      this.logger.debug("Successful sent caretech answer id: ".concat(options.interaction_id));
    } catch (err) {
      this.logger.warn("Error sending caretech answer with id: ".concat(options.interaction_id));
    }
  }
  showAlreadyAnsweredDialog(options) {
    const actions = [];
    actions.push({
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    });
    const dialog = new svs.ui.dialog.Confirm({
      branding: this.isMomang ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
      title: 'Du har redan svarat på den här dialogen',
      icon: 'clock-simple',
      area: svs.ui.dialog.area.POPUP,
      isGamingResponsibility: false,
      allowDimmerClick: false,
      actions
    });
    svs.ui.dialog.api.add(dialog);
    this.logger.debug("Displayed already answered dialog with id: ".concat(options.interaction_id));
  }
  async saveRestriction(selectedTime, options) {
    try {
      const response = await svs.core.jupiter.callAsync({
        path: '/caretech/1/customer/longsession',
        method: 'POST',
        data: {
          interactionId: options.interaction_id,
          selectedDurationMs: (selectedTime * 60 * 1000).toString()
        }
      });
      options.restrictedToTime = response.response.response.RestrictTo;
      this.showConfirmTimeLimit(options);
      this.logger.debug("Successful saved caretech restriction answer with id: ".concat(options.interaction_id));
    } catch (err) {
      this.logger.warn("Error saving caretech restriction answer with id: ".concat(options.interaction_id));
      if (err.code === 70016) {
        this.showAlreadyAnsweredDialog(options);
      } else {
        this.logger.warn("Error sending caretech answer with id: ".concat(options.interaction_id));
      }
    }
  }
  timeLimitButtonClick(e) {
    var _e$target;
    const extendedTime = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    this.shouldDisplayErrorTag(false);
    if (extendedTime !== this.extendedTimeValue) {
      this.extendedTimeValue = extendedTime;
    }
  }
  shouldDisplayErrorTag(showTag) {
    if (showTag) {
      document.querySelector('.js-dialog-popup-items').style.height = null;
      document.getElementById('long-session-check-error-message').style.display = 'inline-flex';
    } else {
      document.getElementById('long-session-check-error-message').style.display = 'none';
    }
  }
  showInitalTimeLimitDialog(el, options) {
    options.mandatory = String(options.mandatory).toLowerCase() === 'true';
    options.title = 'Ibland går tiden fort! Nu har du spelat i över 2 timmar';
    const actions = [];
    if (!options.mandatory) {
      actions.push({
        title: 'Stäng',
        callback: () => {
          dialog.close();
          this.trackInteraction('Close', 'dialog_close', options.mandatory);
          this.caretechTracking('Close', options);
        }
      });
    }
    actions.push({
      title: 'Bekräfta',
      callback: () => {
        if (this.extendedTimeValue !== null) {
          dialog.close();
          this.queueNumber = svs.ui.dialog.api.queue.count() > this.queueNumber ? svs.ui.dialog.api.queue.count() : this.queueNumber;
          this.saveRestriction(this.extendedTimeValue, options);
        } else {
          this.shouldDisplayErrorTag(true);
        }
      }
    });
    const dialog = new svs.ui.dialog.Confirm({
      branding: this.isMomang ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
      title: options.title,
      area: svs.ui.dialog.area.POPUP,
      icon: 'clock-simple',
      isGamingResponsibility: false,
      allowDimmerClick: false,
      actions,
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        text: el(options),
        type: svs.ui.dialog.message.TEXT
      }]
    });
    svs.ui.dialog.api.add(dialog);
    document.querySelectorAll('.js-long-session-check input[type="radio"]').forEach(rb => {
      rb.addEventListener('click', e => this.timeLimitButtonClick(e));
    });
    this.caretechTracking('Displayed', options);
  }
  showConfirmTimeLimit(options) {
    const actions = [];
    actions.push({
      title: 'Okej',
      callback: () => {
        dialog.close();
        this.trackInteraction('Submit', 'dialog_close', options.mandatory);
        this.caretechTracking('Submit', options);
      }
    });
    const dialog = new svs.ui.dialog.Confirm({
      branding: this.isMomang ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
      title: this.getConfirmationTitleText(this.extendedTimeValue),
      icon: 'clock-simple',
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.CONFIRM,
      isGamingResponsibility: false,
      allowDimmerClick: false,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: this.getConfirmationBodyText(this.extendedTimeValue, options.restrictedToTime)
      }],
      actions
    });
    svs.ui.dialog.api.add(dialog);
  }
}
svs.caretech = svs.caretech || {};
svs.caretech.caretech_checks = svs.caretech.caretech_checks || {};
svs.caretech.caretech_checks.LongSession = LongSession;

 })(window);